// Stndard directive to use with angular apps.
// version 1.4.1

/*eslint no-unused-vars: ["error", {
    "varsIgnorePattern": "cpayNGDirectives",
    "argsIgnorePattern": "attrs|filter|timeout|errorResponse|input"
}]*/

////////// Helper functions //////////

function spliceStr(str, index, omit, add) {
    'use strict';
    return str.slice(0, index) + (add || "") + str.slice(index + omit);
}
function setSelection(input, selectionStart, selectionEnd) {
    'use strict';
    if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveEnd('character', selectionEnd);
        range.moveStart('character', selectionStart);
        range.select();
    }
}
function showThousandsSeparator(num) {
    'use strict';
    var parts = num.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

////////// Angular CPAY standard directives //////////

var cpayNGDirectives = {
    backgroundImage: function () {
        // DEPRECIATED
        // Use ngStyle instead.
        'use strict';
        return function (scope, element, attrs) {
            attrs.$observe('backgroundImage', function (value) {
                element.css("background-image", "URL(" + value + ")");
            });
        };
    },
    dateMask: ['$filter', function ($filter) {
        'use strict';
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var dateFormat = attrs.dateMask !== undefined ? attrs.dateMask : "mediumDate";
                    // see format string available to standard Angular filter "date"
                    // https://docs.angularjs.org/api/ng/filter/date
                    // "mediumDate" -> Sep 3, 2010 (default)
                    // "MMMM dd, yy" -> September 03, 10
                function dateFormatter(value) {
                    var returnVal = $filter('date')(value, dateFormat);
                    return returnVal;
                }
                function dateParser(value) {
                    var d = new Date(value),
                        year = d.getFullYear(),
                        month = d.getMonth() + 1,
                        date = d.getDate(),
                        returnVal;
                    if (month < 10) { month = "0" + month; }
                    if (date < 10) { date = "0" + date; }
                    if ($.isNumeric(year)) {
                        returnVal = year + "-" + month + "-" + date;
                    } else {
                        returnVal = scope.prop.expirationDate;
                    }
                    ngModel.$setViewValue(dateFormatter(returnVal));
                    ngModel.$render();
                    return returnVal;
                }
                ngModel.$parsers.push(dateParser);
                ngModel.$formatters.push(dateFormatter);
            }
        };
    }],
    dollarMask: ['$filter', '$timeout', function ($filter, $timeout) {
        'use strict';
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var dec = attrs.dollarMask === "" ? 2 : parseInt(attrs.dollarMask, 10),
                        // pass as dollar-mask="2" -> $888.88 default
                        // dollar-mask="3" -> $88.888
                        // dollar-mask="0" -> $88,888
                    currencySign = attrs.currencySign !== undefined ? attrs.currencySign : "$",
                        // include to change currency symbol
                        // currency-sign="$" (default) --> $8.88
                        // currency-sign="&yen;" --> ¥8.88
                    spaceAfterCurrency = attrs.spaceAfterCurrency !== undefined ? " " : "",
                        // include "space-after-currency" to place a space between the currency sign and the amount
                    currencyOffset = attrs.currencyBeforeNegative !== undefined ? 0 : 1,
                        // include "negative-before-currency" attribute to place negative sign before $ (Ex. -$12.34)
                    allowNegative = attrs.noNegatives !== undefined ? false : true;
                        // include "no-negatives" attribute to disallow negative numbers
                function dollarFormatter(value) {
                    var negative = false,
                        currencyPlace = 0,
                        arrayVal;
                    if (value !== "" && value !== undefined) {
                        arrayVal = value ? value.toString().split("") : '';
                        if (arrayVal[0] === "-") { negative = true; }
                        value = Math.abs(value).toFixed(dec);
                        value = showThousandsSeparator(value);
                        if (negative) {
                            value = "-" + value;
                            currencyPlace += currencyOffset;
                        }
                        value = spliceStr(value, currencyPlace, 0, currencySign + spaceAfterCurrency);
                    }
                    return value;
                }
                function numberParser(value) {
                    var negative = false,
                        carrotPos = 0,
                        el = element[0],
                        sel,
                        newValue,
                        carrotPosOffset = 0;
                    if (document.selection) {
                        el.focus();
                        sel = document.selection.createRange();
                        sel.moveStart('character', -el.value.length);
                        carrotPos = sel.text.length;
                    } else if (el.selectionStart || el.selectionStart === '0' || el.selectionStart === 0) {
                        carrotPos = el.selectionStart;
                    }
                    carrotPosOffset -= value.toString().length;
                    if (value !== "") {
                        value = value.toString().trim();
                        if (allowNegative && value.match(/-/g) !== null && value.match(/-/g).length % 2 !== 0) { negative = true; }
                        value = parseInt(value.replace(/\D/g, ""), 10);
                        value = $.isNumeric(value) ? value / Math.pow(10, dec) : (0).toFixed(dec);
                        if (negative) { value = "-" + value; }
                    }
                    newValue = dollarFormatter(value.toString());
                    carrotPosOffset += newValue.length;
                    carrotPos += carrotPosOffset;
                    ngModel.$setViewValue(newValue);
                    ngModel.$render();
                    $timeout(function () {
                        var range;
                        if (el !== null) {
                            if (el.createTextRange) {
                                range = el.createTextRange();
                                range.move('character', carrotPos);
                                range.select();
                            } else {
                                if (el.selectionStart) {
                                    el.focus();
                                    el.setSelectionRange(carrotPos, carrotPos);
                                } else {
                                    el.focus();
                                }
                            }
                        }
                    });
                    return value;
                }
                ngModel.$parsers.push(numberParser);
                ngModel.$formatters.push(dollarFormatter);
            }
        };
    }],
    focus: function () {
        'use strict';
        return function (scope, element, attrs) { element.focus(); };
    },
    mdAutocompOnBlur: ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            require: '^mdAutocomplete',
            link: function(scope, element, attributes) {
                $timeout(function(){
                    angular.element(element[0].querySelector('input')).bind('blur', function() {
                        $timeout(function() { scope.$eval(attributes.mdAutocompOnBlur); }, 100);
                    });
                });
            }
        };
    }],
    numberMask: ['$filter', '$timeout', function ($filter, $timeout) {
        'use strict';
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var dec = attrs.numberMask === "" ? 0 : parseInt(attrs.numberMask, 10),
                        // pass as number-mask="0" -> 88,888 default
                        // number-mask="2" -> 888.88
                        // number-mask="3" -> 88.888
                    allowNegative = attrs.noNegatives !== undefined ? false : true;
                        // include "no-negatives" attribute to disallow negative numbers
                function numberFormatter(value) {
                    var negative = false,
                        arrayVal;
                    if (value !== "" && value !== undefined) {
                        value = value.toString();
                        arrayVal = value.split("");
                        if (arrayVal[0] === "-") { negative = true; }
                        value = showThousandsSeparator(Math.abs(value).toFixed(dec));
                        if (negative) { value = "-" + value; }
                    }
                    return value;
                }
                function numberParser(value) {
                    var negative = false,
                        carrotPos = 0,
                        el = element[0],
                        sel,
                        newValue,
                        carrotPosOffset = 0;
                    if (document.selection) {
                        el.focus();
                        sel = document.selection.createRange();
                        sel.moveStart('character', -el.value.length);
                        carrotPos = sel.text.length;
                    } else if (el.selectionStart || el.selectionStart === '0' || el.selectionStart === 0) {
                        carrotPos = el.selectionStart;
                    }
                    carrotPosOffset -= value.toString().length;
                    if (value !== "") {
                        value = value.toString().trim();
                        if (allowNegative && value.match(/-/g) !== null && value.match(/-/g).length % 2 !== 0) { negative = true; }
                        value = parseInt(value.replace(/\D/g, ""), 10);
                        value = $.isNumeric(value) ? value / Math.pow(10, dec) : (0).toFixed(dec);
                        if (negative) { value = "-" + value; }
                    }
                    newValue = numberFormatter(value.toString());
                    carrotPosOffset += newValue.length;
                    carrotPos += carrotPosOffset;
                    ngModel.$setViewValue(newValue);
                    ngModel.$render();
                    $timeout(function () {
                        var range;
                        if (el !== null) {
                            if (el.createTextRange) {
                                range = el.createTextRange();
                                range.move('character', carrotPos);
                                range.select();
                            } else {
                                if (el.selectionStart) {
                                    el.focus();
                                    el.setSelectionRange(carrotPos, carrotPos);
                                } else {
                                    el.focus();
                                }
                            }
                        }
                    });
                    return value;
                }
                ngModel.$parsers.push(numberParser);
                ngModel.$formatters.push(numberFormatter);
            }
        };
    }],
    percentMask: ['$filter', function ($filter) {
        'use strict';
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var dec = attrs.percentMask === "" ? 2 : parseInt(attrs.percentMask, 10),
                        // pass as percent-mask="2" -> 888.88% default
                        // percent-mask="3" -> 88.888%
                        // percent-mask="0" -> 88,888%
                    spaceBeforePercent = attrs.spaceBeforePercent !== undefined ? " " : "",
                        // include "space-before-percent" to place a space between the amount and the percentage sign
                    allowNegative = attrs.noNegatives !== undefined ? false : true;
                        // include "no-negatives" attribute to disallow negative numbers
                function percentFormatter(value) {
                    var negative = false,
                        arrayVal;
                    if (value !== "" && value !== undefined) {
                        arrayVal = value.toString().split("");
                        if (arrayVal[0] === "-") { negative = true; }
                        value = showThousandsSeparator(Math.abs(value * 100).toFixed(dec));
                        if (negative) { value = "-" + value; }
                        value = spliceStr(value, value.length, 0, spaceBeforePercent + "%");
                    }
                    return value;
                }
                function numberParser(value) {
                    var viewVal,
                        negative = false;
                    if (value !== "") {
                        value = value.toString().trim();
                        if (allowNegative && value.match(/-/g) !== null && value.match(/-/g).length % 2 !== 0) { negative = true; }
                        value = parseInt(value.replace(/\D/g, ""), 10);
                        value = $.isNumeric(value) ? value / Math.pow(10, dec + 2) : (0).toFixed(dec + 2);
                        if (negative) { value = "-" + value; }
                    }
                    viewVal = percentFormatter(value.toString());
                    ngModel.$setViewValue(viewVal);
                    ngModel.$render();
                    setSelection(element[0], viewVal.length - 1, viewVal.length - 1);
                    return value;
                }
                ngModel.$parsers.push(numberParser);
                ngModel.$formatters.push(percentFormatter);
            }
        };
    }],
    usFaxMask: ['$filter', function ($filter) {
        'use strict';
        return {
            restict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                function numberParser(value) {
                    value = value.toString().trim().replace(/\D/g, '');
                    if (value.charAt(0) === "1" || value.charAt(0) === '0') { value = spliceStr(value, 0, 1, ''); }
                    if (value.length > 10) { value = value.substr(0, 10); }
                    ngModel.$setViewValue($filter('usPhone')(value));
                    ngModel.$render();
                    return value;
                }
                ngModel.$parsers.push(numberParser);
                ngModel.$formatters.push($filter('usPhone'));
            }
        };
    }],
    usPhoneMask: ['$filter', function ($filter) {
        'use strict';
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                function phoneFormatter(value) {
                    value = value ? value.toString().trim().replace(/\D/g, "") : '';
                    if (value.charAt(0) === "1" || value.charAt(0) === "0") { value = spliceStr(value, 0, 1, ""); }
                    if (value) {
                        switch (value.length) {
                        case 0:
                            break;
                        case 1:
                        case 2:
                        case 3:
                            value = "(" + value + ")";
                            break;
                        case 4:
                        case 5:
                        case 6:
                            value = "(" + value.slice(0, 3) + ") " + value.slice(3);
                            break;
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                            value = "(" + value.slice(0, 3) + ") " + value.slice(3, 6) + "-" + value.slice(6);
                            break;
                        default:
                            value = "(" + value.slice(0, 3) + ") " + value.slice(3, 6) + "-" + value.slice(6, 10) + " ext." + value.slice(10);
                        }
                        return value;
                    }
                }
                function numberParser(value) {
                    var viewVal = "";
                    value = value.toString().trim().replace(/\D/g, "");
                    if (value.charAt(0) === "1" || value.charAt(0) === "0") { value = spliceStr(value, 0, 1, ""); }
                    viewVal = phoneFormatter(value);
                    ngModel.$setViewValue(viewVal);
                    ngModel.$render();
                    if (viewVal && viewVal.length > 2 && viewVal.length < 6) {
                        setSelection(element[0], viewVal.length - 1, viewVal.length - 1);
                    }
                    return value;
                }
                ngModel.$parsers.push(numberParser);
                ngModel.$formatters.push(phoneFormatter);
            }
        };
    }],
    zipCodeMask: function () {
        'use strict';
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                function zipFormatter(value) {
                    if (value) {
                        value = value.toString();
                        if (value.length > 5) { value = value.substring(0, 5) + "-" + value.substring(5, 9); }
                    }
                    return value;
                }
                function numberParser(value) {
                    value = value.toString().trim().replace(/\D/g, "");
                    value = value.substring(0, 9);
                    ngModel.$setViewValue(zipFormatter(value));
                    ngModel.$render();
                    return value;
                }
                ngModel.$parsers.push(numberParser);
                ngModel.$formatters.push(zipFormatter);
            }
        };
    },
    zipLookup: ['$http', '$timeout', function ($http, $timeout) {
        // Bug: A user rapidly deleting and replacing the 5th digit may cause the server script
        // to overwork.
        'use strict';
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                ngModel: "=",
                zipLookup: "@",
                    // This is the destination of the JSON call. You must include the model and any other variable
                    // within this URL.
                    // Ex. "../json/zip-{{myZip | zipUnderFive}}.json"
                    // Note: A call will never occur if the model does not have a length smaller than 5.
                zipCity: "=",
                    // This is the model to which the response city will be assigned.
                zipState: "=",
                    // This is the model to which the response state will be assigned.
                zipStateType: "@",
                    // "initial" or "full"
                    // Assign as "initial" if you'd like the state initial to be assigned in zipState.
                    // Assign as "full" if you'd like the full state name to be assigned in zipState.
                zipNotOnLoad: "@",
                    // Include this attribute ("zip-not-on-load") if you do not want the script to run on the initial
                    // load. In other words, include this if you are loading a value for state from the database,
                    // unless you want the page to double check the zip after loading.
                zipLoadingModel: "=",
                    // This scope variable will evaulate to true if when the script is making a AJAX call.
                zipErrorClass: "@"
                    // This class will be assigned to the input when an AJAX call returns an error.
            },
            link: function (scope, element, attrs, ngModel) {
                var doOnLoad = scope.zipNotOnLoad === undefined ? true: false,
                    initialDone = false;
                function doAJAXCall(repeat, destination) {
                    var ajaxTimer;
                    scope.zipLoadingModel = true;
                    element.removeClass(scope.zipErrorClass);
                    if (repeat) {
                        clearTimeout(ajaxTimer);
                        ajaxTimer = setTimeout(function () { doAJAXCall(false, destination); }, 1000);
                    } else {
                        $http.get(destination)
                            .success(function (zipResponse) {
                                if (zipResponse.city) { scope.zipCity = zipResponse.city; }
                                if (scope.zipStateType === "full" && zipResponse.state) {
                                    scope.zipState = zipResponse.state;
                                } else if (zipResponse.st) { scope.zipState = zipResponse.st; }
                                if (!zipResponse.city && !zipResponse.st && !zipResponse.state) { element.addClass(scope.zipErrorClass); }
                                scope.zipLoadingModel = false;
                            })
                            .error(function (errorResponse) {
                                element.addClass(scope.zipErrorClass);
                                scope.zipLoadingModel = false;
                            });
                    }
                }
                scope.$watch('ngModel', function (newVal, oldVal) {
                    if (newVal && oldVal) {
                        newVal = newVal.toString().trim().replace(/\D/g, "").slice(0, 5);
                        oldVal = oldVal.toString().trim().replace(/\D/g, "").slice(0, 5);
                    }
                    if (newVal !== oldVal && ngModel.$modelValue.length >= 5) {
                        if (initialDone || doOnLoad) doAJAXCall(true, scope.zipLookup);
                        initialDone = true;
                    }
                });
            }
        };
    }],
    zipUnderFiveNGFilter: function () {
        // Use this filter inconjunction with the zipLookUp directive to pass only the first five digits of the input.
        // .filter('zipUnderFive', cpayNGDirectives.zipUnderFiveNGFilter)
        'use strict';
        return function (input) {
            if (input) {
                return input.toString().trim().replace(/\D/g, "").slice(0, 5);
            }
        };
    }
};
